import { useState } from 'react';
import PlusIcon from '../../../assets/icons/plus.svg?react';
import AlertTargetAppendSideModal from './AlertTargetAppendSideModal';
import Pagination from '../../../components/Pagination/Pagination';
import { SkeletonTable } from '../../../components/Skeleton';
import { useSearchParams } from 'react-router-dom';
import { useNotificationTargetList } from '../../../hooks/queries/logQueries';
import DeleteIcon from '../../../assets/icons/delete.svg?react';
import AlertTargetDeleteModal from './AlertTargetDeleteModal';
const AlertTargetManagement = () => {
  const [isAppendModalOpen, setIsAppendModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [target, setTarget] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();


  const currentPage = parseInt(searchParams.get('page')) || 1;
  const pageSize = parseInt(searchParams.get('pageSize')) || 10;
  const sortBy = searchParams.get('sortBy') || 'CreatedDate';
  const sortOrder = searchParams.get('sortOrder') || 'desc';
  const keyword = searchParams.get('keyword') || '';
  const status = searchParams.get('status') || '';

  const { data: notificationTargetList, isLoading: isLoadingNotificationTargetList, refetch: refetchNotificationTargetList } = useNotificationTargetList();
  const totalPages = notificationTargetList?.Total ? Math.ceil(notificationTargetList.Total / pageSize) : 1;
  
  const handlePageChange = (page) => {
    setSearchParams({ ...searchParams, page: page.toString() });
  };
  const handleSort = (field, order) => {
    setSearchParams({ ...searchParams, sortBy: field, sortOrder: order });
  };
  const handleSearch = () => {
    setSearchParams({ ...searchParams, page: 1 });
  };
  const handleAppendModalOpen = () => {
    setIsAppendModalOpen(true);
  };

  const handleAppendModalClose = () => {
    setIsAppendModalOpen(false);
  };
  const handleDelete = (target) => {
    setTarget(target);
    setDeleteModalOpen(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
  };
  const handleDeleteSuccess = () => {
    refetchNotificationTargetList();
    handleDeleteModalClose();
  };
  return (
    <div className="alert-target-management-container">
      <div className="flex flex-col gap-10">
        <div className="flex align-center justify-end">
          <button className="btn big-btn btn-primary flex align-center gap-2" onClick={handleAppendModalOpen}>
            <PlusIcon />
            알림 대상 추가
          </button>
        </div>
        <div className="primary-table">
          <table>
            <thead>
              <tr>
                <th>대상타입</th>
                <th>대상값</th>
                <th width="80px"></th>
              </tr>
            </thead>
            <tbody>
                {isLoadingNotificationTargetList ? (
                  <SkeletonTable rows={pageSize} columns={2} />
                ) : (
                  notificationTargetList?.Items?.map((item) => (
                    <tr key={item.NotificationTargetSysId}>
                      <td>{item.TargetType}</td>
                      <td>{item.TargetValue}</td>
                      <td>
                        <button className="btn icon-btn" onClick={() => handleDelete(item)}>
                          <DeleteIcon color='var(--gray-600)'/>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
            </tbody>
          </table>
        </div>
        <div className="pagination-wrapper">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            size="medium"
          />
        </div>
      </div>
      {isAppendModalOpen && (
        <AlertTargetAppendSideModal onClose={handleAppendModalClose} />
      )}
      {deleteModalOpen && (
        <AlertTargetDeleteModal onClose={handleDeleteModalClose} target={target} onSuccess={handleDeleteSuccess} />
      )}
    </div>
  )
}

export default AlertTargetManagement